// @flow
import React from 'react';
import { illustrationColor, productColor } from '../designSystem.js';
import { usePrintMode } from '../jsx-activity/usePrintMode.js';

type Props = {|
  openByDefault?: boolean,
  title: React$Node,
  children: React$Node,
|};

export function SolidifyCollapsibleInternal(props: Props) {
  const printMode = usePrintMode();
  const [_open, setOpen] = React.useState(props.openByDefault || false);
  const open = printMode || _open;

  return (
    <div style={{ marginTop: 24, marginBottom: 24, breakInside: 'avoid' }}>
      <div
        style={{ display: 'table', height: 33, cursor: 'pointer' }}
        onClick={React.useCallback(() => setOpen(!open), [open])}
      >
        <div style={{ display: 'table-cell', verticalAlign: 'middle' }}>
          <svg
            width="12"
            height="7.5"
            viewBox="0 0 8 5"
            fill="none"
            style={{
              display: 'table-cell',
              verticalAlign: 'middle',
              transform: open ? 'rotate(180deg)' : undefined,
            }}
          >
            <path
              d="M3.60957 4.51196L0.649878 0.812348C0.387973 0.484966 0.621059 0 1.04031 0H6.95969C7.37894 0 7.61203 0.484966 7.35012 0.812348L4.39043 4.51196C4.19027 4.76216 3.80973 4.76216 3.60957 4.51196Z"
              fill={illustrationColor.cloudburst}
            />
          </svg>
        </div>
        <div
          style={{
            display: 'table-cell',
            verticalAlign: 'middle',
            width: '100%',
            paddingLeft: '1.25em',
          }}
        >
          <h1
            style={{
              fontStyle: 'normal',
              fontWeight: 600,
              fontSize: '1em',
              lineHeight: 0,
              margin: 0,
              color: '#34495e',
              width: '100%',
              display: 'table-cell',
              verticalAlign: 'middle',
            }}
          >
            {props.title}
          </h1>
        </div>
      </div>

      <div
        style={{
          // When we are closed we still want children to be in the DOM
          // AND (critically) we want the children to exist in the box tree
          // as well, so that we can perform accurate layout measurements.
          // This combination of styles ensures children exist in the box
          // tree, but do not affect layout, nor are drawn to the screen.
          visibility: open ? 'visible' : 'hidden',
          height: open ? 'auto' : 0,
          paddingTop: 16,
          color: productColor.shuttleGrey,
        }}
      >
        {props.children}
      </div>
    </div>
  );
}
